import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import LanguageDropdown from './LanguageDropdown';
import Brand from './Brand';

const NAV = [
  { href: '#platform', key: 'training' },
  { href: '#nutrition', key: 'nutrition' },
  { href: '#recipes', key: 'recipes' },
  { href: '#grocery', key: 'shop' },
];

export default function Header({ lang, setLang, t }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-paper/95 backdrop-blur-md border-b border-line shadow-sm'
          : 'bg-paper/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-[72px]">
          <Brand />

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((item) => (
              <a
                key={item.key}
                href={item.href}
                className="text-[13px] font-bold uppercase tracking-[0.16em] text-ink/75 hover:text-ember transition-colors"
              >
                {t.nav[item.key]}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <LanguageDropdown lang={lang} setLang={setLang} />
            <a
              href="/s"
              className="px-5 py-2.5 bg-ink text-paper text-[13px] font-bold uppercase tracking-[0.14em] hover:bg-ember hover:text-ink transition-colors duration-200"
            >
              {t.header.login}
            </a>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <LanguageDropdown lang={lang} setLang={setLang} />
            <button
              className="p-2 text-ink"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-cream border-t border-line px-4 py-4 flex flex-col gap-2">
          {NAV.map((item) => (
            <a
              key={item.key}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="px-2 py-3 text-sm font-bold uppercase tracking-[0.14em] border-b border-line"
            >
              {t.nav[item.key]}
            </a>
          ))}
          <a
            href="/s"
            className="mt-2 px-5 py-3 bg-ink text-paper text-sm font-bold uppercase tracking-[0.14em] text-center"
          >
            {t.header.login}
          </a>
        </div>
      )}
    </header>
  );
}
